export const enum CategoryType {
  STANDARD = 'STANDARD',
  DISPLAY = 'DISPLAY',
}
